/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1ExamMessageCount200,
  GetApiV1ExamMessageCount401,
  GetApiV1ExamMessageCount500,
  GetApiV1ExamMessageCountQueryResponse,
} from "../../types/examSharedController/GetApiV1ExamMessageCount.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1ExamMessageCount200Schema = z
  .number()
  .int() as unknown as ToZod<GetApiV1ExamMessageCount200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1ExamMessageCount401Schema =
  z.any() as unknown as ToZod<GetApiV1ExamMessageCount401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1ExamMessageCount500Schema =
  z.any() as unknown as ToZod<GetApiV1ExamMessageCount500>;

export const getApiV1ExamMessageCountQueryResponseSchema = z.lazy(
  () => getApiV1ExamMessageCount200Schema,
) as unknown as ToZod<GetApiV1ExamMessageCountQueryResponse>;
